import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useLinkPreview } from '@/hooks/useLinkPreview';
import { LinkPreviewCard } from '@/components/link-preview/link-preview-card';

interface LinkPreviewProps {
  url: string;
  className?: string;
}

export function LinkPreview({ url, className = '' }: LinkPreviewProps) {
  const { preview, loading, error } = useLinkPreview(url);

  if (loading) {
    return (
      <div className={`border border-slate-200 dark:border-slate-800 rounded-lg p-4 bg-slate-50 dark:bg-slate-900 animate-pulse ${className}`}>
        <div className="flex gap-3">
          <div className="w-16 h-16 bg-slate-200 dark:bg-slate-800 rounded"></div>
          <div className="flex-1">
            <div className="h-4 bg-slate-200 dark:bg-slate-800 rounded mb-2"></div>
            <div className="h-3 bg-slate-200 dark:bg-slate-800 rounded w-3/4"></div>
          </div>
        </div>
      </div>
    );
  }

  if (preview) {
    return <LinkPreviewCard {...preview} className={className} />;
  }

  if (error) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={`block border border-slate-200 dark:border-slate-800 rounded-lg p-4 bg-white dark:bg-slate-900 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors ${className}`}
      >
        <div className="flex items-center justify-between gap-3">
          <div className="min-w-0">
            <div className="font-semibold text-slate-900 dark:text-white truncate">External Link</div>
            <div className="text-xs text-slate-500 dark:text-slate-400 truncate">{url}</div>
          </div>
          <ExternalLink className="w-4 h-4 text-slate-500" />
        </div>
      </a>
    );
  }

  return null;
}